import { Component, OnInit, ViewEncapsulation, ViewChild, Input, Output, EventEmitter, ElementRef, ViewContainerRef, OnChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DQOIService } from '@app/cp/shared/services/DQOI.service';
import { AutoCompleteComponent, ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { DQOISearchParam } from '@app/cp/shared/models/DQOISearchParam';
import { SearchTarget } from '@app/cp/shared/enums/SearchTarget';
import { ControlType } from '@app/cp/shared/enums/ControlTypes';
import { DQOISearchEvent } from '@app/cp/shared/models/DQOISearchEvent';
//import { lang } from 'moment';
import { SearchBy } from '@app/cp/shared/enums/SearchBy';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { v_QuickSearchBus } from '@app/cp/shared/models/v_QuickSearchBus';
//import { GridComponent } from '@progress/kendo-angular-grid';
import { CPSearchInputParam } from '@app/cp/shared/models/CPSearchInputParam';
import { CommonParam } from '@app/cp/shared/models/CommonParam';

@Component({
    selector: 'construction-quick-search',
    templateUrl: './construction-quick-search.component.html',
    styleUrls: ['./construction-quick-search.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ConstructionQuickSearchComponent implements OnInit, OnChanges {
    SearchTarget: SearchTarget;
    advSearchInputParam: CPSearchInputParam = new CPSearchInputParam();

    @ViewChild("searchAC") ac: AutoCompleteComponent;
    @Input() minSearchSize: number = 3;
    @Input() showFound: boolean = true;
    @Input() searchTarget: SearchTarget = SearchTarget.contract;
    @Output() selected: EventEmitter<any> = new EventEmitter<any>();
    customerId: any;
    searchDataValue: v_QuickSearchBus;
    readOnly: boolean = false;
    isActive: boolean = true;
    loading: boolean = false;
    searchTargetEnum: any = SearchTarget;
    event: DQOISearchEvent = new DQOISearchEvent();
    public searchText: string;
    data: v_QuickSearchBus[];
    searchWidth = Math.max(window.innerWidth - 220, 200); //TODO BW: Check math for responsive
    searchParam: DQOISearchParam = new DQOISearchParam();
    subscriptions: Subscription[] = [];
    quickSearchAnchor: ViewContainerRef;
    public searchFilter: string;

    constructor(private globals: GlobalsService, private svc_data: DQOIService) {

        this.advSearchParam = new CommonParam();
        this.subscriptions.push(svc_data.quickSearchAnchor$.subscribe( anchor => {
            this.quickSearchAnchor = anchor;
        }));
    }

    //@ViewChild("container", { read: ViewContainerRef }) public containerRef: ViewContainerRef;

    ngOnInit() {
        console.log("const-srch=init");
        this.searchParam.minStringSize = this.minSearchSize;
        this.changeSearchText();
    }
    ngOnDestroy() {
        this.subscriptions.forEach(subscription => {subscription.unsubscribe()}
        );
    }

    public opened: boolean;
    @ViewChild("search") searchField: ElementRef;
    searchWindow() {
        this.opened = !this.opened;
    }
    searchFocus(): void {
        setTimeout(() => { // this will make the execution after the above boolean has changed
            this.searchField.nativeElement.focus();
        }, 0);
    }

    filterChange(filter: string) {
        this.searchWidth = Math.max(window.innerWidth - 250, 200);

        if (!CommonFunctions.hasStringValue(filter) || filter.toString().length < this.minSearchSize) {
            this.data = [];
            return;
        }
        this.setLoading(true);
        this.searchParam.userId = this.globals.userId;
        this.searchParam.search = filter.trim();
        this.searchParam.searchTarget = this.searchTarget;
        this.searchParam.startDate = new Date(2013, 1, 1);
        this.searchParam.isOpen = this.isActive;

        this.svc_data.cnst_QuickSearch(this.searchParam).subscribe((data: v_QuickSearchBus[]) => {
            this.data = data;

            this.setLoading(false);
        });
        if (filter.length > 2) {
            this.searchFilter = filter;
        }
    }
    setLoading(loading: boolean) {
        this.loading = loading;
    }
    /**********************************************************************
     * 0 - Location Name
     * 1 - DispatchNumber
     * 2 - PONumber
     * 3 - WONumber
     * 4 - InvoiceNumber
     * 5 - QuoteNumber
     * 6 - OrderNumber
     * 7 - dispatchId
     **********************************************************************/
    valueChange(value: any) {
        //  this.searchDataValue = value;
        this.data = [];
        if (value.length == 36 && value.includes('-')) {
            this.event.clear();
            this.event.searchTarget = this.searchTarget;
            this.event.dispatchId = value;
            this.event.id = value;
        }
        else {
            return;
        }
        /*
        var arr: string[] = value.split(" :: ");
        var dispatchId = arr[6];
        //  var res = this.data.filter(data => data.quickSearchKey === value);
        this.event.clear();
        this.event.searchTarget = this.searchTarget;
        this.event.dispatchId = arr[7];
        this.event.poNumber = CommonFunctions.getArraySubstringValue(arr, 2, 2, '');
        this.event.woNumber = CommonFunctions.getArraySubstringValue(arr, 3, 2, '');
        this.event.invoiceNumber = CommonFunctions.getArraySubstringValue(arr, 4, 2, '');
        this.event.quoteNumber = CommonFunctions.getArraySubstringValue(arr, 5, 2, '');
        this.event.orderNumber = CommonFunctions.getArraySubstringValue(arr, 6, 2, '');
        //this.event.dispatchId = arr[7];
        //this.event.poNumber =   arr[2].substr(2);
        //this.event.woNumber = arr[3].substr(2);
        //this.event.invoiceNumber =  arr[4].substr(2);
        //this.event.quoteNumber = arr[5].substr(2);
        //this.event.orderNumber = arr[6].substr(2);
        let searchBy: string = value.substr(0, 1).toUpperCase();
        if (value.charAt(1) === '-') {
            switch (searchBy) {
                case 'D':
                    this.event.searchBy = SearchBy.dispatch;
                    break;
                case 'P':
                    this.event.searchBy = SearchBy.po;
                    break;
                case 'W':
                    this.event.searchBy = SearchBy.wo;
                    break;
                case 'I':
                    this.event.searchBy = SearchBy.invoice;
                    break;
                case 'Q':
                    this.event.searchBy = SearchBy.quote;
                    break;
                case 'O':
                    this.event.searchBy = SearchBy.order;
                    break;
            }
        }
        */
        this.svc_data.nextSearchEvent(this.event);
        this.selected.emit(this.event);
        //    this.ac.reset();
        this.ac.text = "";
        this.ac.toggle(false);
        this.ac.reset();

    }
    get reasonTitle(): string {
        if (this.searchTarget == SearchTarget.order) return "Supplier";
        return "Reason";
    }
    get hidePOColumn(): boolean {
        if (this.searchTarget == SearchTarget.order) return true;
        return false;
    }
    get hideWOColumn(): boolean {
        if (this.searchTarget == SearchTarget.order) return true;
        return false;
    }

    goTo(value: any, searchTarget: any) {
        this.data = [];
        if (value.length == 36 && value.includes('-')) {
            this.event.clear();
            this.event.searchTarget = searchTarget;
            this.event.dispatchId = value;
            this.event.id = value;
        }
        else {
            return;
        }
        /*
        var arr: string[] = value.split(" :: ");
        var dispatchId = arr[6];
        //  var res = this.data.filter(data => data.quickSearchKey === value);
        this.event.clear();
        this.event.searchTarget = this.searchTarget;
        this.event.dispatchId = arr[7];
        this.event.poNumber = CommonFunctions.getArraySubstringValue(arr, 2, 2, '');
        this.event.woNumber = CommonFunctions.getArraySubstringValue(arr, 3, 2, '');
        this.event.invoiceNumber = CommonFunctions.getArraySubstringValue(arr, 4, 2, '');
        this.event.quoteNumber = CommonFunctions.getArraySubstringValue(arr, 5, 2, '');
        this.event.orderNumber = CommonFunctions.getArraySubstringValue(arr, 6, 2, '');
        //this.event.dispatchId = arr[7];
        //this.event.poNumber =   arr[2].substr(2);
        //this.event.woNumber = arr[3].substr(2);
        //this.event.invoiceNumber =  arr[4].substr(2);
        //this.event.quoteNumber = arr[5].substr(2);
        //this.event.orderNumber = arr[6].substr(2);
        let searchBy: string = value.substr(0, 1).toUpperCase();
        if (value.charAt(1) === '-') {
            switch (searchBy) {
                case 'D':
                    this.event.searchBy = SearchBy.dispatch;
                    break;
                case 'P':
                    this.event.searchBy = SearchBy.po;
                    break;
                case 'W':
                    this.event.searchBy = SearchBy.wo;
                    break;
                case 'I':
                    this.event.searchBy = SearchBy.invoice;
                    break;
                case 'Q':
                    this.event.searchBy = SearchBy.quote;
                    break;
                case 'O':
                    this.event.searchBy = SearchBy.order;
                    break;
            }
        }
        */

        this.svc_data.nextSearchEvent(this.event);
        this.selected.emit(this.event);
        this.ac.reset();
        this.ac.value = "";
        this.ac.text = "";
        this.ac.reset();
    }
    customerSelected(value: any) {

    }
    public cellClick({  dataItem }): void {
        this.valueChange(dataItem.id)
    }
    openChanged(e: any) {
        this.isActive = e;
    }
    targetChanged(e: any, target: number) {
        if (e === true) {
            this.searchTarget = target;
            if (CommonFunctions.hasStringValue(this.searchParam.search) && this.searchParam.search.length >= this.minSearchSize) {
                this.filterChange(this.searchParam.search);
                this.ac.toggle(true);
            }
            this.changeSearchText()
        }

    }
    ngOnChanges() {
        this.changeSearchText();
    }
    changeSearchText() {
        switch(this.searchTarget) {
            case SearchTarget.contract:
                return this.searchText = 'Contracts';
            case SearchTarget.job:
                return this.searchText = 'Jobs';
            case SearchTarget.quote:
                return this.searchText = 'Bids';
            case SearchTarget.order:
                return this.searchText = 'Orders';
            case SearchTarget.invoice:
                return this.searchText = 'Invoices';
        }
        console.log('seach text:' + this.searchText)
    }
    advSearch: boolean = false;
    advSearchParam: CommonParam;
    doAdvSearch() {
        switch (this.searchTarget) {
            case SearchTarget.contract:
                this.advSearchInputParam.code = "Dispatch";
                this.advSearchInputParam.customInputCode = "ISCONSTRUCTIONCONTRACT"
                this.advSearchInputParam.customInputValue = "isConstruction";
                this.advSearch = true;
                this.advSearchInputParam.openSearch = true;
                break;
            case SearchTarget.job:
                this.advSearchInputParam.code = "Dispatch";
                this.advSearchInputParam.customInputCode = "ISCONSTRUCTION"
                this.advSearchInputParam.customInputValue = "isConstruction";
                this.advSearch = true;
                this.advSearchInputParam.openSearch = true;
                break;
            case SearchTarget.quote:
                this.advSearchInputParam.code = "Quotes";
                this.advSearchInputParam.customInputCode = "ISCONSTRUCTION"
                this.advSearchInputParam.customInputValue = "isConstruction";
                this.advSearch = true;
                this.advSearchInputParam.openSearch = true;
                break;
            case SearchTarget.order:
                this.advSearchInputParam.code = "Orders";
                this.advSearchInputParam.customInputCode = "ISCONSTRUCTION"
                this.advSearchInputParam.customInputValue = "isConstruction";
                this.advSearch = true;
                this.advSearchInputParam.openSearch = true;
                break;
            case SearchTarget.invoice:
                this.advSearchInputParam.code = "Invoices";
                this.advSearchInputParam.customInputCode = "ISCONSTRUCTION"
                this.advSearchInputParam.customInputValue = "isConstruction";
                this.advSearch = true;
                this.advSearchInputParam.openSearch = true;
                break;
        }
    }
    advSearchSelected(dataItem: any) {

        this.advSearch = false;
        this.advSearchInputParam.openSearch = false;
        if (dataItem) {
            let id = null;
            switch(this.searchTarget) {
                case SearchTarget.contract:
                    id = dataItem.DispatchId;
                    break;
                case SearchTarget.job:
                    id = dataItem.DispatchId;
                    break;
                case SearchTarget.quote:
                    id = dataItem.QuoteId;
                    break;
                case SearchTarget.order:
                    id = dataItem.OrderId;
                    break;
                case SearchTarget.invoice:
                    id = dataItem.InvoiceId;
                    break;
            }
            this.valueChange(id);
        }
    }
}
